import React from "react";
import styled from "styled-components";

const StyledSection = styled.section`
  max-width: 1260px;
  margin: 0 auto;
  padding: 0 clamp(28px, 6vw, 80px) 110px;

  .wrap {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    border-top: 1px solid var(--border-light);
    border-bottom: 1px solid var(--border-light);

    @media (max-width: 920px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 560px) {
      grid-template-columns: 1fr;
    }
  }

  .item {
    padding: 30px 22px;
    position: relative;
  }

  .item:not(:last-child):after {
    content: "";
    position: absolute;
    top: 26px;
    right: 0;
    width: 1px;
    height: calc(100% - 52px);
    background: var(--border-light);
  }

  .title {
    margin: 0 0 10px;
    font-size: clamp(24px, 3vw, 30px);
    font-weight: 600;
    letter-spacing: -0.03em;
    color: var(--text-primary);
  }

  .desc {
    font-size: 14px;
    line-height: 1.7;
    color: var(--text-secondary);
    max-width: 240px;
  }

  @media (max-width: 920px) {
    .item:nth-child(2):after {
      display: none;
    }
  }

  @media (max-width: 560px) {
    .item:after {
      display: none !important;
    }

    .item {
      border-bottom: 1px solid var(--border-light);
    }

    .item:last-child {
      border-bottom: 0;
    }
  }
`;

const SignalStrip = () => {
  return (
    <StyledSection>
      <div className="wrap">
        <div className="item">
          <div className="title">Messy → Structured</div>
          <div className="desc">
            Turning unstructured, inconsistent data into clean, usable systems.
          </div>
        </div>

        <div className="item">
          <div className="title">Logic First</div>
          <div className="desc">
            Clear thinking before tools. Systems built on reasoning, not guesswork.
          </div>
        </div>

        <div className="item">
          <div className="title">End-to-End</div>
          <div className="desc">
            From raw inputs to outputs that actually get used in real workflows.
          </div>
        </div>

        <div className="item">
          <div className="title">Built to Last</div>
          <div className="desc">
            Code and systems designed to be reliable, explainable, and maintainable.
          </div>
        </div>
      </div>
    </StyledSection>
  );
};

export default SignalStrip;